import { Injectable } from '@angular/core';
import { DialogService } from '@mode/shared/ui';
import { CollectionManageAccessFacade } from '@mode/collections/domain';

import { AccessDialogsContainerComponent } from './access-dialogs-container/access-dialogs-container.component';
import { filter, first } from 'rxjs/operators';
import { isPresent } from '@mode/shared/util-js';
import { CollectionAccessLevel, SpaceType } from '@mode/shared/contract-common';

@Injectable()
export class CollectionManageAccessModalService {
  readonly MODAL_WIDTH = 478;
  readonly MODAL_HEIGHT = 600;

  constructor(
    private dialogService: DialogService,
    private collectionManageAccessFacade: CollectionManageAccessFacade
  ) {
    collectionManageAccessFacade.entitlementErrored$.pipe(filter(isPresent), first()).subscribe(() => {
      dialogService.closeAll();
    });
  }

  manage(
    workspaceName: string,
    collectionId: string,
    overallAccess: CollectionAccessLevel,
    collectionType: SpaceType,
    routingEnabled = false
  ) {
    return this.dialogService
      .open({
        component: AccessDialogsContainerComponent,
        matDialogConfig: {
          width: `${this.MODAL_WIDTH}px`,
          height: `${this.MODAL_HEIGHT}px`,
          data: {
            workspaceName,
            overallAccess,
            collectionId,
            collectionType,
            routingEnabled,
          },
        },
      })
      .afterClosed();
  }
}
